/**
 * Keep only type → parent levels for the main catalog page.
 * Product and container nodes are stripped from display (CRUD remains elsewhere).
 */
export function shallowProductTypesTree(nodes: any[]): any[] {
  if (!nodes || !Array.isArray(nodes)) {
    console.debug("[shallowProductTypesTree] empty input");
    return [];
  }

  let strippedProductCount = 0;
  let parentCount = 0;

  const result = nodes.map((node: any) => {
    if (node.type === "type") {
      const children = (node.children || []).map((child: any) => {
        if (child.type === "parent") {
          parentCount += 1;
          const nested = child.children || [];
          strippedProductCount += nested.filter(
            (n: any) => n.type === "product" || n.type === "container"
          ).length;
          // Also count nested containers under products
          nested.forEach((n: any) => {
            if (n.type === "product" && n.children) {
              strippedProductCount += n.children.length;
            }
          });
          return {
            ...child,
            children: undefined
          };
        }
        return child;
      });
      return {
        ...node,
        children
      };
    }

    if (node.type === "parent") {
      parentCount += 1;
      const nested = node.children || [];
      strippedProductCount += nested.length;
      nested.forEach((n: any) => {
        if (n.type === "product" && n.children) {
          strippedProductCount += n.children.length;
        }
      });
      return {
        ...node,
        children: undefined
      };
    }

    return node;
  });

  console.debug("[shallowProductTypesTree]", {
    rootCount: result.length,
    parentCount,
    strippedProductCount
  });

  return result;
}
